import {Button} from '@/shadcn_components/ui/button';
import {UseDialogStateReturn} from '@/hooks/useDialogState';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shadcn_components/ui/dialog';
import {useDelete} from '@refinedev/core';
import {useCallback} from 'react';
import {defaultMutationOptions} from '@/pages/_utils';

export type DeleteConfirmDialogProps = {
  dialogState: UseDialogStateReturn;
  title?: string;
  content?: string;
  onSuccess?: () => void;
};

export const DeleteConfirmDialog = ({
  dialogState,
  title,
  content,
  onSuccess,
}: DeleteConfirmDialogProps) => {
  const {resource, id} = dialogState.extraData || {};

  const {mutate: deleteOne} = useDelete({mutationOptions: defaultMutationOptions});

  const doDelete = useCallback(async () => {
    try {
      await deleteOne({resource, id: String(id)}, {onSuccess});
      dialogState.closeDialog();
    } catch (err) {
      console.error('Delete error', err);
    }
  }, [deleteOne, resource, id, dialogState]);

  if (!dialogState.open) return null;

  if (!resource || !id) return null;

  return (
    <Dialog open={dialogState.open} onOpenChange={dialogState.toggleDialog}>
      <DialogContent>
        <DialogTitle>{title || `Bạn có muốn xóa? (${resource}/${id})`}</DialogTitle>
        <DialogDescription>{content || `Bạn có muốn xóa mục này?`}</DialogDescription>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={e => {
              e.stopPropagation();
              dialogState.closeDialog();
            }}
            className="mr-1">
            <span>Không</span>
          </Button>
          <Button
            variant="destructive"
            onClick={e => {
              e.stopPropagation();
              doDelete();
            }}>
            <span>Có</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
